import parse from 'html-react-parser';

export default function Message({ children, message }) {
    if (message) {
        return <div>{parse(message)}</div>;  // Wrapped in <div> to ensure valid JSX
    }

    if (children) {
        return <div>{parse(children)}</div>;  // Wrapped in <div>
    }

    return null;
}
